<template>
  <div>
    <h1 class="text-center">Hvalpe</h1>

    <div class="text-center mt-4">
      <p>Hillsbrook Kira blev tirsdag mor til 8 skønne gule hvalpe. Der er 7 hanner og 1 lille pige. De er efter DK FTCH DK TM MPM 2013 Jobeshill Olof (Brimson).</p>

      <p>Der er 2 søde drenge tilbage.</p>

      <!-- Todo: Gør billedet tekst til et link -->
      <p>Du kan se mere om Jobeshill Olof ved at klikke her eller på billedet nedenunder.</p>
    </div>

    <!-- Todo: Mindre height? -->
    <v-img :src="`${publicPath}images/FTCH Jobeshill Olof.jpg`"></v-img>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Hvalpe',
  data: () => ({
    publicPath: process.env.BASE_URL
  }),
  computed: {
    ...mapState(['test', 'dogs'])
  }
};
</script>
